<div class="overlay" *ngIf="loading$ | async">
  <div class="logo__inner">
    <img src="assets/images/loading-logo.png" class="img-fluid" alt="logo" />
    <div class="progress-bar">
      <div class="progress-bar-fill" [style.width.%]="progress$ | async"></div>
    </div>
  </div>
</div>
